export default __webpack_public_path__ + "static/media/scales.01023946.png";